import { IRequestInterceptor, JWTRequestInterceptor } from './RequestInterceptors';
import { checkReportAxiosInstance } from './axios';
import { AxiosResponse } from 'axios';
import { Check } from '../types/check/types';

export type ErrorResponse = {
	errors: string;
};

export type UpdateReportResponse = {
	status: string;
	errors?: Array<string>;
};

export class CheckReportService {
	private _jwtInterceptor: IRequestInterceptor;

	constructor(interceptor: IRequestInterceptor) {
		this._jwtInterceptor = interceptor;
	}

	public async fetchReport(): Promise<AxiosResponse<Check> | AxiosResponse<ErrorResponse>> {
		return await this.sendRequest(this._fetchReport);
	}

	public async putPersonaData(data: any): Promise<AxiosResponse<UpdateReportResponse>> {
		return await this.sendRequest(async () => await this._putPersonaData(data));
	}

	public async putReportData(data: any) {
		return await this.sendRequest(() => this._putReportData(data));
	}

	public async fetchIDAustriaAuthRedirectionLink() {
		return await this.sendRequest(() => this._fetchIDAustriaAuthRedirectionLink());
	}

	private async sendRequest(request: () => Promise<any>) {
		return await this._jwtInterceptor.interceptRequest(request);
	}

	private async _fetchReport() {
		return await checkReportAxiosInstance.get('');
	}

	private async _putPersonaData(data: any) {
		return await checkReportAxiosInstance.put('', data);
	}

	private async _putReportData(data: any) {
		return await checkReportAxiosInstance.put('', data);
	}

	private async _fetchIDAustriaAuthRedirectionLink() {
		return await checkReportAxiosInstance.get('');
	}
}

const jwtRequestInterceptor = new JWTRequestInterceptor();
export const checkReportAPI = new CheckReportService(jwtRequestInterceptor);
